var React = require('react');

function Coffee (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.4 29V16.4c0-1.1-.9-2-2-2s-2 .9-2 2V29c0 1.1.9 2 2 2s2-.9 2-2zM57.4 33.4V20.7c0-1.1-.9-2-2-2s-2 .9-2 2v12.7c0 1.1.9 2 2 2s2-.9 2-2zM31.4 33.4V20.7c0-1.1-.9-2-2-2s-2 .9-2 2v12.7c0 1.1.9 2 2 2s2-.9 2-2zM14.4 83.6c0 1.1.9 2 2 2h51.3c1.1 0 2-.9 2-2s-.9-2-2-2H56.8c3.9-2.4 7.3-5.7 9.6-9.7h9.4c5.4 0 9.8-4.4 9.8-9.8s-4.4-9.8-9.8-9.8h-5.4v-7.2c0-1.1-.9-2-2-2H16.5c-1.1 0-2 .9-2 2v12.6c0 10.2 5.4 19.1 13.6 24H16.4c-1.1-.1-2 .8-2 1.9zm61.4-27.3c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8h-7.4c1.3-3.2 2-6.7 2-10.3v-1.4h5.4zm-57.3 1.4V47.1h47.9v10.6c0 13.2-10.7 24-24 24s-23.9-10.8-23.9-24z"}));
}

Coffee.defaultProps = {"height":"100","width":"100","viewBox":"0 0 100 100"};

module.exports = Coffee;

Coffee.default = Coffee;
